/**
 * Übergabe „Mitteilung angetippt" vom Service Worker an die App.
 *
 * Drei Wege, weil iOS keinen davon verlässlich macht: die Adresse beim Öffnen,
 * eine Nachricht an die schon laufende App — und diese Ablage im Cache, die die
 * App beim Start und bei jeder Rückkehr in den Vordergrund liest. Beim
 * Kaltstart aus einer Mitteilung kam am iPhone weder Adresse noch Nachricht an
 * (Geräteabnahme 09.10.2026).
 *
 * Ohne DOM-Abhängigkeit: Service Worker und App lesen dieselben Konstanten.
 */

export const NOTIFICATION_CACHE = 'kraftwerk-notification';
export const NOTIFICATION_CLICK_KEY = '/__kraftwerk/notification-click';
export const NOTIFICATION_CLICK_MESSAGE = 'kraftwerk:notification-click';

/** Älteres wird ignoriert: Ein Antippen von gestern ist kein Ziel mehr. */
export const STORED_CLICK_MAX_AGE_MS = 2 * 60 * 1000;

export interface StoredClick {
  url: string;
  at: number;
}

/** Abgelegtes Antippen holen und dabei entfernen — höchstens einmal verwertet. */
export async function takeStoredClick(now: number = Date.now()): Promise<StoredClick | null> {
  if (typeof caches === 'undefined') return null;
  try {
    const cache = await caches.open(NOTIFICATION_CACHE);
    const response = await cache.match(NOTIFICATION_CLICK_KEY);
    if (!response) return null;
    await cache.delete(NOTIFICATION_CLICK_KEY);

    const data = (await response.json()) as Partial<StoredClick>;
    if (typeof data.url !== 'string' || typeof data.at !== 'number') return null;
    if (now - data.at > STORED_CLICK_MAX_AGE_MS) return null;
    return { url: data.url, at: data.at };
  } catch {
    return null;
  }
}
